module.exports = __webpack_public_path__ + "static/media/character_sound_x3.c5f63604.mp3";